

































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import AppUserUnit from "@/components/atom/AppUserUnit.vue";
import {User, UserComment} from "@/params/User";
import vuescroll from 'vuescroll';

@Component({
  components: {
    AppUserUnit,
    vuescroll
  },
  computed: mapState([ 'user' ])
})
export default class LiveStreamingCommentsUnit extends Vue {
  /* mapState Property */
  private user: User;

  /* Data */
  private commentText: string = '';
  private valid: boolean = false;


  /* Property */
  @Prop() isShown: boolean;
  @Prop() comments: UserComment[];
  @Prop() sending: boolean;

  /**
   * ゲストアイコンを取得する
   */
  get guestThumbnailUrl (): string {
    return this.$store.getters.guestUserIcon;
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  /**
   * ユーザーのサムネイル写真をチェック
   * 写真画像が存在しない場合はnoImageの時のユーザーサムネイルを返す
   */
  private getUserThumbnailUrl (thumbnailUrl: string): string {
    if (thumbnailUrl && thumbnailUrl !== '') {
      return thumbnailUrl;
    }
    else {
      return this.$store.getters.noImageUserIcon;
    }
  }


  /* LifeCycleHook */
  mounted (): void {
    console.log('Comment Unit Mounted');
  }

  /* Event Listeners */
  onSubmitComment (ev: any): void {
    this.$emit('submit-comment', {
      username: this.user.name,
      commentText: this.commentText,
      thumbnailUrl: this.user.thumbnailUrl,
      isGuest: this.user.isGuest
    });

    this.commentText = '';
  }

  /**
   * ユーザーサムネイル画像のが404エラーだった場合のイメージハンドラ
   * サムネイル写真をnoImage時のユーザーサムネイルに差し替える
   * @param commentIndex エラーが発生したコメントのインデックス
   */
  private onThumbnailNotFoundError (commentIndex: number): void {
    const comment = this.comments[commentIndex];
    console.log('Thumbnail Image 404: ' + commentIndex);
    console.log(comment.thumbnailUrl);
    comment.thumbnailUrl = this.$store.getters.noImageUserIcon;
  }

}
